module.exports = __webpack_public_path__ + "static/img/136.a5f85b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/136.png
// module id = h0Es
// module chunks = 0